import { Divider, IconButton, Stack, styled, Typography } from '@ethings/ui-toolkit';
import { Slide, useTheme } from '@mui/material';
import { unstable_styleFunctionSx as unstableStyleFunctionSx } from '@mui/system';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { scrollbar } from '../../../../style';
import { ToggleLayers } from '../../../../types';
import { Icon } from '../../../icons';
import { MapScrollableWrapper } from '../../../wrapper/map-scrollable-wrapper';
import { SLIDE_DURATION } from '../layer-selection';
import { SubMenuSectionController } from './sub-menu-section-controller';
import { getSubSectionData } from './sub-menu.util';

interface Props {
  closeSubMenu: () => void;
  height?: number;
  selectedSubMenu: ToggleLayers;
  width?: number;
}

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  marginRight: theme.spacing(0.5),
  padding: 0,
}));

const ScrollableStack = styled(Stack)(({ theme }) => ({
  ...(unstableStyleFunctionSx({ sx: scrollbar, theme } as never) as Record<string, unknown>),
}));

export const SubMenu: FC<Props> = ({
  closeSubMenu,
  height,
  selectedSubMenu,
  width,
}) => {
  const { t } = useTranslation(['common']);
  const theme = useTheme();

  return (
    <MapScrollableWrapper>
      <Slide direction="left" in={!!selectedSubMenu} timeout={SLIDE_DURATION}>
        <ScrollableStack overflow="auto" height={height} width={width}>
          <Stack direction="row" alignItems="center" pb={1}>
            <StyledIconButton data-testid="close-sub-menu-button" onClick={closeSubMenu}>
              <Icon data-testid="icon-chevron-left" icon="ChevronLeft" style={{ color: theme.palette.common.black }} />
            </StyledIconButton>
            <Typography>{t(`common:component.map.layers.labels.${selectedSubMenu}`)}</Typography>
          </Stack>
          <Divider />
          {getSubSectionData(selectedSubMenu).map(({ cacheDataTypes, cacheFilter, itemType, storageKey, typePropertyName }) =>
            <SubMenuSectionController
              key={itemType}
              cacheDataTypes={cacheDataTypes}
              cacheFilter={cacheFilter}
              label={t(`common:component.map.layers.labels.${itemType}`)}
              storageKey={storageKey}
              typePropertyName={typePropertyName}
            />,
          )}
        </ScrollableStack>
      </Slide>
    </MapScrollableWrapper>
  );
};
